import { jsx as _jsx } from "react/jsx-runtime";
import CustomState from './CustomState';
const ErrorState = (props) => {
    const { icon = 'rioglyph-truck-breakdown', ...remainingProps } = props;
    return _jsx(CustomState, { icon: icon, ...remainingProps });
};
export default ErrorState;
